import React, { Component } from 'react'
import Config from '../../commons/config/Config.js'
import Security from '../../commons/security/Security.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import moment from 'moment'
import 'moment/min/locales'
import '../../assets/css/chat-application.css'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import Timezone from '../../commons/timezone/Timezone.js';

class TicketComentarios extends Component {
	constructor(props) {
    super(props);
    this.props = props;

    this.ajaxHandler = new AjaxHandler();

    moment.locale('es');

    if(props.ticket) {
      this.ticket = props.ticket;
    }

    this.state = {
      loading: false,
      inputComentario: null,
      comentarios: [],
      personas: []
    };

    this.handleInputComentarioChange = this.handleInputComentarioChange.bind(this);
    this.handleEnviar = this.handleEnviar.bind(this);
  }

  componentDidMount(nextProps, nextState) {
    this.ajaxHandler.subscribe(this);
    this.loadFormData();
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  buildPhoto(foto) {
    if (foto) {
      let photoUrl = Config.get('apiUrlBase') + '/personas/foto/' + foto;
      fetch(photoUrl, {
        method: 'GET',
        headers: {
          'Authorization-Token': localStorage.getItem("token")
        }
      }).then(response => {
        if (response.status === 200) {
          response.blob().then(imageBlob => {
             return  URL.createObjectURL(imageBlob);
          });
        }
      });
    }
  }

  loadFormData() {
    let component = this;
    this.setState({ loading: true });
    this.ajaxHandler.getJson('/ticket-comentarios/ticket/' + this.ticket.id + '/grid')
    .then(data => {
      if(data) component.setState({
        comentarios: data
      });

      let personas = data.map(e => 
                      e.persona
                    ).filter((e, index, self) => 
                      index === self.findIndex((i) => 
                        i.id === e.id
                      )
                    );

      const photoUrl = '/personas/foto/';
      personas.map((e) => {
        if(e.foto) {
          component.ajaxHandler.fetch(photoUrl + e.foto, {
            method: 'GET'
          }).then(response => {
            if (response.status === 200) {
              return response.blob();
            }
          }).then(imgBlob => {
            let fileUrl = URL.createObjectURL(imgBlob);
            e.fotoUrl = fileUrl;
          }).catch(() => {
          }).finally(() => {
            let personas = component.state.personas;
            personas.push(e);
            component.setState({
              personas: personas
            });
          });
        } else {
          let personas = component.state.personas;
          personas.push(e);
          component.setState({
            personas: personas
          });
        }
      });
    }).finally(() => {
      this.setState({ loading: false });
    });
  }

  handleInputComentarioChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		this.setState({
			inputComentario: { comentario: value }
		});
  }

  handleEnviar(event) {
    this.setState({ loading: true });
		let component = this
		this.ajaxHandler.fetch('/ticket-comentarios/ticket/' + this.ticket.id, {
			method: 'POST',
			body: JSON.stringify(this.state.inputComentario)
		}).then(response => {
      if(response.status !== 400) {
        this.setState({
          inputComentario: null
        }, () => {
          component.loadFormData();
        });
      } else {
        response.json()
        .then(data => {
          this.setState({
            errors: data.detalle
          });
        });
      }
		}).catch((error) => {
			this.ajaxHandler.handleError(error);
		}).finally(() => {
      this.setState({ loading: false },
      () =>{
        this.props.callbackUpdate();
      });
		});
		event.preventDefault();
  }

	render() {
    if(this.ticket) {
      let persona = JSON.parse(localStorage.getItem('persona'));
      let usuarioLogueado = persona.usuario.usuario;
      return (
        <React.Fragment>
          {this.state.loading && <Loading />}
          <div className="card pull-up">
            <div className="card-content pl-1 pr-1">
              <div className="card-body">
                <h4 className="form-section">
                  <i className="la la-comments"></i><FormattedMessage id="tipoFormularioAbm.render.comments.header_comentarios" defaultMessage=" Comentarios"/>
                </h4>
                <div className="row chat-application ml-0 mr-0 mb-1">
                  <div className="content-body">
                    {Security.hasPermission('TICKETS_COMENTAR') ? (
                    <section className="chat-app-form" style={{display:  this.props.action === 'VIEW' ? 'none': ''}}>
                      <div className="row">
                        <div className="col-md-11">
                          <input type="text" className="form-control ml-1" id="inputComentario" name="inputComentario" placeholder={this.props.intl.formatMessage({ id: 'tipoFormularioAbm.render.comments.placeholder_ingrese_aqui_su_comentario', defaultMessage: 'Ingrese aquí su comentario' })} value={this.state.inputComentario ? this.state.inputComentario.comentario : ''} onChange={this.handleInputComentarioChange} />
                        </div>
                        <div className="col-md-1">
                          <button className={this.state.inputComentario ? 'btn btn-float-sm btn-round btn-fleet ml-1' : 'btn btn-float-sm btn-round btn-fleet ml-1 disabled' } data-tooltip="tooltip" data-placement="top" title="" data-original-title={this.props.intl.formatMessage({ id: 'tipoFormularioAbm.render.comments.button_title_enviar', defaultMessage: 'Enviar' })} onClick={this.handleEnviar}>
                            <i className="la la-send align-middle"></i>
                          </button>
                        </div>
                      </div>
                    </section>
                    ) : ''}
                    <section className="chat-app-window">
                      <div className="chats">
                        <div className="chats">
                        {
                          this.state.comentarios.map((comentario, index)=>{
                            let persona = this.state.personas.filter(p => p.id === comentario.persona.id)[0];
                            return persona && (
                              <div className="pb-3" key={index}>
                                <p className="time">{ Timezone.getDateForClient(comentario.fechaHora, null, 'YYYY-MM-DD hh:mm:ss') }</p>
                                <div className={comentario.usuario.usuario === usuarioLogueado ? "chat chat-left" : "chat"}>
                                  <div className="chat-avatar">
                                    <div className={persona.fotoUrl ? 'dt-user-avatar-image' : 'dt-user-avatar'} style={{display: 'inline-block', backgroundImage: persona.fotoUrl ? 'url(' + persona.fotoUrl + ')' : ''}} data-toggle="tooltip" data-placement={comentario.usuario.usuario === usuarioLogueado ? "left" : "right"} title={comentario.usuario.usuario} data-original-title="">
                                      {!persona.fotoUrl ? persona.nombre.substr(0, 1).toUpperCase() + persona.apellido.substr(0, 1).toUpperCase() : ''}
                                    </div>
                                    <p className="mb-0">{comentario.persona.nombre}</p>
                                    <p>{comentario.persona.apellido}</p>
                                  </div>
                                  <div className="chat-body">
                                    <div className="chat-content">
                                      <p>{comentario.comentario}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        }
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    } else {
      return null;
    }
  }
}

export default injectIntl(TicketComentarios);